import Header from "./components/header/Header"
import Tabs from "./components/tabs/Tabs"
import TabContent from "./components/tabContent/TabContent"
import Preview from "./components/preview/Preview"
import Generate from "./components/generate/Generate"
import config from "./config.json"
import { useState } from "react"
import LanguageBubble from "./components/language/LanguageBubble"
import { LanguageProvider, useLanguage } from "./contexts/LanguageContext"
import "./ressource/css/components/multiLanguage.css"
import "./ressource/css/custoPreview.css"

/**
 * Generates initial parameters from config with default values
 * @returns {Object} Parameters object with selectedTab and element defaults
 */
const getParametersFromConfig = () => {
  let parameters = {}

  Object.keys(config.tabContent).forEach((key, index) => {
    if (index === 0) parameters = { ...parameters, selectedTab: key }

    config.tabContent[key].forEach(element => {
      parameters = { ...parameters, [element.id]: element.default }
      if (element.type === "FileUpload") parameters = { ...parameters, [`${element.id}_file`]: element.default }
    })
  })

  return parameters
}

/**
 * Main application content component.
 * Manages parameters, selected languages, and renders the UI.
 */
function AppContent() {
  const configParameters = getParametersFromConfig()
  const [parameters, setParameters] = useState(configParameters)
  const [selectedLanguages, setSelectedLanguages] = useState([])
  const [overlayChecked, setOverlayChecked] = useState(false)
  const [highlightStrokeChecked, setHighlightStrokeChecked] = useState(false)
  const { t, currentLanguage } = useLanguage()

  return (
    <div className="container-fluid">
      <LanguageBubble />
      <Header />
      <div className="row">
        <div className="col-5">
          <div className="colBloc border rounded">
            <Tabs parameters={parameters} setParameters={setParameters} />
            <TabContent
              parameters={parameters}
              setParameters={setParameters}
              onLanguagesChange={setSelectedLanguages}
              overlayChecked={overlayChecked}
              setOverlayChecked={setOverlayChecked}
              highlightStrokeChecked={highlightStrokeChecked}
              setHighlightStrokeChecked={setHighlightStrokeChecked}
            />
          </div>
        </div>
        <div className="col-7 mw800">
          <div className="colBloc border rounded" style={{ position: "relative" }}>
            {overlayChecked && <div className="preview-overlay-bg" style={{ background: parameters.modalShadowBgColor || "rgba(0,0,0,0.5)" }} />}
            <Preview parameters={parameters} overlayChecked={overlayChecked} highlightStrokeChecked={highlightStrokeChecked} />
          </div>
        </div>
      </div>
      <div className="row">
        <button
          className="btn btn-success generateBtn"
          onClick={() => {
            Generate(parameters, selectedLanguages, currentLanguage)
            setParameters(getParametersFromConfig())
          }}
        >
          {t("Body.fileGeneration")}
        </button>
      </div>
    </div>
  )
}

function App() {
  return (
    <LanguageProvider>
      <AppContent />
    </LanguageProvider>
  )
}

export default App
